/* import __COLOCATED_TEMPLATE__ from './settings.hbs'; */
/* RESPONSIBLE TEAM: team-integration-apps */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type ImportConfigurationService from 'embercom/services/data/import-configuration-service';
import type Owner from '@ember/owner';
import { action } from '@ember/object';

export interface Args {}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class Settings extends Component<Signature> {
  @service declare intl: IntlService;
  @service('data/import-configuration-service')
  declare importConfigurationService: ImportConfigurationService;

  findOrganizationBySourceObjectIdSetting: boolean;

  constructor(owner: Owner, args: Args) {
    super(owner, args);
    this.findOrganizationBySourceObjectIdSetting =
      this.importConfigurationService.findOrganizationBySourceObjectIdSetting;
  }

  @action toggleFindOrganizationBySourceObjectIdSetting() {
    this.importConfigurationService.setFindOrganizationBySourceObjectIdSetting(
      !this.findOrganizationBySourceObjectIdSetting,
    );
  }

  translation = (path: string) => this.intl.t(this.translationKey(path));
  private translationKey = (path: string) =>
    `new-settings.data.imports-exports.import-zendesk.config-import-page.sections.company.settings.${path}`;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Data::ImportsExports::ImportZendesk::ConfigImport::Sections::Company::Settings': typeof Settings;
    'new-settings/data/imports-exports/import-zendesk/config-import/sections/company/settings': typeof Settings;
  }
}
